const USER_EDITABLE_FIELDS = {
  PHONE_NUMBER: 'phoneNumber',
  EMAIL: 'email',
  ADDRESS: 'address',
  ADDRESS1: 'address1',
  ZIP_CODE: 'zipcode',
  CITY: 'city',
  STATE: 'state',
};

const USER_STATUS = {
  ACTIVE: 'active',
  DEACTIVATED: 'deactivated',
  DNA: 'DNA',
  ONBOARDING_INCOMPLETE: 'onboardingIncomplete',
  SUSPENDED: 'suspended',
  UNVERIFIED: 'unverified',
};

module.exports = {  USER_EDITABLE_FIELDS, USER_STATUS };